import React from 'react';
import { publicSiteUrl } from 'src/common';
import { Button, ButtonParamType, DefaultButtonStyle } from '../button/revamp-button';
import { Modal } from '../modal/modal';
import './underage-modal.scss';

type UnderAgeModalProps = {
  visible: boolean;
  heading?: string;
  subtext?: string;
  cancelButtonLabel?: string;
  onClose?: () => void;
  onExitApplication?: () => void;
  automationIdPrefix?: string;
};

export const UnderAgeModal = ({
  visible = false,
  heading = 'Please Note',
  subtext = 'You must be at least 18 years or older to sign up for this service.',
  cancelButtonLabel = 'Close application',
  onClose = () => {},
  onExitApplication = () => {},
  automationIdPrefix,
}: UnderAgeModalProps) =>
  visible ? (
    <Modal visible={visible} size="small" onClose={onClose}>
      <h1 className="confirm-modal-heading">{heading}</h1>
      <p className="greyed-sub-heading">{subtext}</p>
      <Button
        buttonStyle={DefaultButtonStyle()
          .hasPrimaryAction()
          .isMediumSize()
          .hasDarkMode()
          .build()}
        buttonParams={{
          type: ButtonParamType.NormalButton,
          onClick: () => {
            onExitApplication();
            window.location.href = publicSiteUrl;
          },
        }}
        className="underage-button"
        automationid={`${automationIdPrefix}_${cancelButtonLabel}_Button`}
      >
        {cancelButtonLabel}
      </Button>
    </Modal>
  ) : (
    <></>
  );
